import axios from 'axios';

export default {
  async getTransactions(params, type) {
    return axios.get(`/api/enduser/transaction/${type}/${params.from}/${params.to}/${params.page ? params.page - 1 : 0}`);
  },
  async getTransactionsNonPage(params, type) {
    return axios.get(`/api/enduser/transaction/${type}/${params.from}/${params.to}/no_page`);
  },
}
